import './SearchBar.scss';
import * as React from 'react';
import classNames from 'classnames';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import Icon from '../Icon';
import { isSearchStateEqual } from 'src/Pages/CoursePortal/SeachPage/Search.utils';

export interface ISearchBarState {
  searchQuery: string;
  theme: null | number;
  searchScope: 'all' | 'relevant';
}

export interface ISearchBarProps {
  className?: string;
  style?: React.CSSProperties;
  themes: IActivityThemeModel[];
  initialState?: ISearchBarState;
  onSearch?: (searchState: ISearchBarState) => any;
  onChange?: (searchState: ISearchBarState) => any;
}

const SearchBar = ({
  className,
  themes,
  onSearch,
  onChange,
  initialState,
  ...props
}: ISearchBarProps) => {
  const [state, setState] = React.useState<ISearchBarState>(() => {
    return {
      searchQuery: initialState?.searchQuery || '',
      theme: initialState?.theme || null,
      searchScope: initialState?.searchScope || 'all'
    }
  });

  React.useEffect(() => {
    if (initialState) {
      setState(initialState);
    }
  }, [initialState]);

  React.useEffect(() => {
    if (onChange && (initialState && isSearchStateEqual(state, initialState) === false)) {
      onChange(state);
    }
  }, [state]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (onSearch) {
      onSearch(state);
    }
  };

  const handleThemeChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    let themeId = null;

    if (target.value) {
      themeId = parseInt(target.value, 10);
      if (isNaN(themeId)) {
        themeId = null;
      }
    }

    setState({
      ...state,
      theme: themeId
    });
  };

  const handleSearchTermInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, searchQuery: event.target.value });
  };

  const handleSearchScopeChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    setState({
      ...state,
      searchScope: target.value === 'all' ? 'all' : 'relevant'
    });
  };

  return (
    <form
      className={classNames(
        'CourseSearchBar',
        className,
      )}
      onSubmit={handleSubmit}
      {...props}
    >
      <h3>Søg kursus</h3>
      <div className="CourseSearchBarInner">
        <input
          type="text"
          placeholder="Indtast søgeord her…"
          value={state.searchQuery}
          onChange={handleSearchTermInput}
        />
        <div className="select">
          <select
            value={state.theme || ''}
            onChange={handleThemeChange}
          >
            <option value="">Alle temaer</option>
            {themes.map((theme) => (
              <option key={theme.themeId} value={theme.themeId}>{theme.name}</option>
            ))}
          </select>
          <Icon name="chevron-down" />
        </div>
        <div className="select">
          <select
            onChange={handleSearchScopeChange}
          >
            <option value="all">Alle kurser</option>
            <option value="relevant">Relevante kurser</option>
          </select>
          <Icon name="chevron-down" />
        </div>
        <button type="submit">
          Søg
          <Icon name="search" />
        </button>
      </div>
    </form>
  );
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.tsx